<template>
  <div class="row">
    <!--  题目类型标签列表  -->
    <div class="flex xs12">
      <va-card title="题目类型标签">
        <div class="row">
          <div class="flex md9 sm6 xs12">
            <va-button class="mb-2" flat disabled color="danger">总计{{totalCount}}条结果</va-button>
          </div>
          <div class="flex md3 xs12 sm6">
            <div class="d-flex justify--end">
              <va-button color="red" small outline :to="{ name: 'listPositionTag'}">返回职位列表</va-button>
              <va-button color="info" small outline :to="{ name: 'saveQuestionTag' , params: { positionTagId: positionTagId }}">创建题目类型标签</va-button>
            </div>
          </div>
        </div>
        <va-data-table
          :fields="fields"
          :data="tags"
          :loading="loading"
          :totalPages="totalPages"
          @page-selected="listQuestionTag"
          api-mode
        >
          <!--  排序  -->
          <template slot="sort" slot-scope="props">
            <va-input
              v-model="props.rowData.sortNum"
              type="number"
              oninput="if(value <0)value=1"
              :min="1"
              v-bind:style="{margin: '1rem auto', width: '50%'}"
            >
              <va-button slot="append" icon="ion-md-checkmark ion" color="info" small @click="updateSortNum(props.rowData)">
              </va-button>
            </va-input>
          </template>
          <template slot="tagType" slot-scope="props">
            <va-badge :color=computeTagType(props.rowData.tagType).color>
              {{ computeTagType(props.rowData.tagType).text }}
            </va-badge>
          </template>
          <template slot="actions" slot-scope="props">
            <va-popover message="编辑" placement="top">
              <va-button flat small color="gray" icon="fa fa-pencil"
                :to='{path:`updateQuestionTag/${props.rowData.id}`}'/>
            </va-popover>
            <va-popover message="删除" placement="top">
              <va-button message="删除" placement="top" flat small color="gray" icon="fa fa-trash"
                @click="deleteModal = true;deleteId=props.rowData.id"/>
            </va-popover>
          </template>
        </va-data-table>

        <va-modal
          v-model="deleteModal"
          title="删除题目类型标签"
          okText="提交"
          position="center"
          message="请再次确认是否要删除？"
          @ok="confirmDelete"
        />

      </va-card>
    </div>
  </div>
</template>

<script>

import questionTagApi from '../../api/interview/questionTag'
import { INTERVIEW_TAG_TYPE, INTERVIEW_TAG_TYPES, TAG_TYPE, TAG_TYPES } from '../../utils/constants'
import { computeTagType, formatTime } from '../../utils/common'
export default {
  data () {
    return {
      message: ['Required field'],
      // serviceId: 3,
      name: '',
      tagType: INTERVIEW_TAG_TYPE.QUESTION_TAG.CODE,
      positionTagId: null,
      loading: true,
      pageNumber: 1,
      pageSize: 10,
      totalPages: 1,
      totalCount: 0,
      deleteModal: false,
      deleteId: null,
      tags: [],
      tagTypes: INTERVIEW_TAG_TYPES,
    }
  },
  computed: {
    fields () {
      return [
        {
          name: '__slot:sort',
          title: '排序',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'name',
          title: '题目类型标签名称',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:tagType',
          title: '标签类型',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: 'createTime',
          title: '创建时间',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
        {
          name: '__slot:actions',
          title: '操作',
          width: '20%',
          titleClass: 'text-center',
          dataClass: 'text-center',
        },
      ]
    },
  },
  created () {
    this.positionTagId = this.$route.params.positionTagId
    this.listQuestionTag()
  },
  methods: {
    listQuestionTag (pageNumber = this.pageNumber) {
      this.loading = true
      const params = {
        pageNumber: pageNumber,
        pageSize: this.pageSize,
        type: this.tagType,
        positionTagId: this.positionTagId,
      }
      questionTagApi.listQuestionTag(params).then(response => {
        this.tags = response.tags
        this.tags.forEach(x => {
            x.createTime = formatTime(x.createTime)
          })
        this.totalPages = response.pages.totalPage
        this.totalCount = response.pages.totalCount
        this.pageNumber = pageNumber
        this.loading = false
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    confirmDelete () {
      if (this.deleteId === null) return
      questionTagApi.deleteQuestionTag(this.deleteId).then(response => {
        if (response.success === true) {
          this.showToast('删除题目类型标签成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listQuestionTag()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    updateSortNum: function (params) {
      const data = {
        sortNum: params.sortNum,
        tagType: params.tagType,
      }
      questionTagApi.updateQuestionTag(params.id, data).then(response => {
        if (response.success === true) {
          this.showToast('更新排序成功', {
            duration: 1000,
            icon: 'fa-check',
            position: 'top-center',
            fullWidth: false,
          })
          this.listQuestionTag()
        }
      }).catch(error => {
        this.showToast(error.msg, {
          duration: 1000,
          icon: 'fa-warning',
          position: 'top-center',
          fullWidth: false,
        })
      })
    },
    computeTagType (tagType) {
      return computeTagType(tagType)
    },
  },
}

</script>
<style lang="scss">
.data-table-server-pagination---avatar {
  width: 60px;
  height: 60px;
  border-radius: 50%;
}
</style>
